'use client'
import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { cx } from '@monorepo/helper/cx'

const SmallNumberBox = ({
  title,
  backgroundColor,
  borderColor,
  titleColor,
  bigTitle,
  children,
  animationProps,
}: any) => {
  return (
    <AnimationOnScroll
      {...animationProps}
      className="flex h-full w-full flex-col items-center border border-solid px-4 text-center uppercase"
      style={{
        scrollSnapAlign: 'center',
        background: backgroundColor,
        borderColor: borderColor,
      }}
    >
      <div className="flex flex-grow items-center justify-center pt-12">
        {children}
      </div>
      <span
        className={cx(
          'w-full whitespace-pre-line px-6 py-4',
          bigTitle && 'text-xl sm:text-2xl',
        )}
        style={{ color: titleColor }}
      >
        {title}
      </span>
    </AnimationOnScroll>
  )
}

export default SmallNumberBox
